import React, { useState } from "react";
import { TabContent } from "./TabContent";
import { TabNavItem } from "./TabNavItem";
import { tabsType } from "../../types/common";

interface TabsProps {
	actionButton?: React.ReactElement;
	definition: tabsType;
}

export function Tabs({ actionButton, definition }: TabsProps) {
	const initialActiveTab = definition[0].id;
	const [activeTab, setActiveTab] = useState(initialActiveTab);

	const [items, panes] = definition.reduce(
		([items, panes]: [React.ReactNode[], React.ReactNode[]], item) => {
			const { id, title, content, loading } = item;

			items.push(
				<TabNavItem
					key={id}
					id={id}
					title={title}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>,
			);

			panes.push(
				<TabContent
					key={id}
					id={id}
					activeTab={activeTab}
					content={content}
					loading={loading}
				/>,
			);

			return [items, panes];
		},
		[[], []],
	);

	return (
		<div className="tabs">
			<nav className="tabs-nav">
				<ul role="tablist" className="tabs-list">
					{items}
					{actionButton && <li className="tab-item tab-action-item">{actionButton}</li>}
				</ul>
			</nav>
			<div className="tabs-content">{panes}</div>
		</div>
	);
}
